<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <!-- <layoutheader></layoutheader> -->
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-7 col-lg-8 col-xl-12">
            <!-- <h4 class="card-title-main">ADD DOCTOR</h4> -->
            <form id="demo-form" @submit.prevent="onSubmit">
              <div class="card-body pt-0">
                <!-- Tab Menu -->
                <nav class="user-tabs mb-4">
                  <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                    <li class="nav-item">
                      <a class="nav-link active" data-bs-toggle="tab" @click="setActiveTab('personal')">Personal
                        Information</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-bs-toggle="tab" @click="setActiveTab('social')">Social media</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div v-if="activeTab === 'personal'">
                <div class="card-body">
                  <p v-if="errorvalidation">
                    <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
                      {{ errorvalidation
                      }}
                    </b-alert>
                  </p>
                  <div>
                    <b-alert v-model="showError" dismissible variant="danger">{{ error }}</b-alert>
                  </div>
                  <div>
                    <b-alert v-model="showSuccessAlert" variant="success" dismissible>{{ successMessage }}</b-alert>
                  </div>
                  <div class="card">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">
                            Name <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span>
                          </label>
                          <input type="text" ref="doctorNameInput" class="form-control"
                            v-model="doctorDetails.doctorname" maxlength="100" @input="validateName"
                            :class="{ 'is-invalid': nameError }">
                          <div class="invalid-feedback" v-if="nameError">{{ nameError }}</div>

                          <!-- <input type="text" ref="inputBox" /> -->

                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">
                            Email ID <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                          <input type="text" ref="doctorNameEmail" class="form-control" v-model="doctorDetails.email"
                            maxlength="100" @input="validateEmail" :class="{ 'is-invalid': emailError }">
                          <div class="invalid-feedback" v-if="emailError">{{ emailError }}</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">
                            Age <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                          <input type="text" ref="doctorNameAge" class="form-control" v-model="doctorDetails.age"
                            maxlength="2" @input="validateAge" :class="{ 'is-invalid': ageError }" />
                          <div class="invalid-feedback" v-if="ageError" maxlength="5">{{ ageError }}</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Gender <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                          <select class="form-control" v-model="doctorDetails.gender">
                            <option v-for="gender in genders" :key="gender.value" :value="gender.value">
                              {{ gender.label }}
                            </option>
                            <div class="invalid-feedback" v-if="genderError">{{ genderError }}</div>
                          </select>

                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Languages
                            Spoken</label>
                          <VueMultiselect v-model="doctorDetails.languagesspoken" :options="languageOptions" :max="5"
                            placeholder="Select languages" label="label" track-by="value" multiple>
                            <template slot="tag" slot-scope="{ option }">
                              <span class="custom__tag">{{ option.label }}</span>
                            </template>
                          </VueMultiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Registrations</h4>
                    <div class="registrations-info">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">
                            Registration Info <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span>
                          </label>
                          <input type="text" ref="doctorNameReg" class="form-control"
                            v-model="doctorDetails.registration_info" maxlength="50"
                            :class="{ 'is-invalid': regError }" />
                          <div class="invalid-feedback" v-if="regError">{{ regError }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Clinic Info</h4>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">

                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Clinic Name
                            <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                          <input type="text" ref="doctorNameClinic" class="form-control"
                            v-model="doctorDetails.clincorhospname" maxlength="100"
                            :class="{ 'is-invalid': clinicError }" />
                          <div class="invalid-feedback" v-if="clinicError">{{ clinicError }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Contact Details</h4>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">

                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Address
                            <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                          <textarea ref="doctorNameAddress" class="form-control" v-model="doctorDetails.address"
                            maxlength="500" :class="{ 'is-invalid': addressError }"></textarea>
                          <div class="invalid-feedback" v-if="addressError">{{ addressError }}</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Area <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                          <select v-model="selectedCityOption" class="form-control"
                            :class="{ 'is-invalid': areaError }" :disabled="citiesLoading"
                            @change="onCityOptionChange">
                            <option :value="null" disabled>
                              {{ citiesLoading ? "Loading cities..." : "Select an area" }}
                            </option>
                            <option v-for="city in cities" :key="city.city_id" :value="city.city_id">
                              {{ city.name }}
                            </option>
                            <option :value="otherCityValue">{{ otherCityLabel }}</option>
                          </select>
                          <input v-if="isManualCity" type="text" class="form-control mt-2"
                            v-model="manualCityName" :maxlength="cityNameMaxLength"
                            :class="{ 'is-invalid': areaError }" placeholder="Enter city name" />
                          <div class="invalid-feedback" v-if="areaError">{{ areaError }}</div>
                          <small v-if="citiesError" class="text-danger d-block mt-1">{{ citiesError }}</small>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Area Code
                            <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                          <input type="text" ref="doctorNameAreaCode" class="form-control"
                            v-model="doctorDetails.areacode" maxlength="10" @input="validateAreacode"
                            :class="{ 'is-invalid': areacodeError }" />
                          <div class="invalid-feedback" v-if="areacodeError">{{ areacodeError }}</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Contact
                            Numbers</label>
                          <vue-tel-input class="form-control floating" mode='national' @on-input="updateInput"
                            @focus="onFocus" @blur="phoneTouched = true" :defaultCountry='defaultCountry'
                            :autoFormat="autoFormat" :only-countries="onlyCountries"
                            :inputOptions="{ showDialCode: true, maxlength: 15 }" :dropdownOptions="dropdownOptions"
                            :validCharactersOnly='true' ref="phonenumber" @keypress="validateNumber" />
                          <div class="invalid-feedback d-block" v-if="conError || contactError">
                            {{ conError || contactError }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card services-card">
                  <div class="card-body">
                    <h4 class="card-title">Services and Specialization</h4>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Specialization
                          <span
                            style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                        <select class="form-control" v-model="doctorDetails.specialization"
                          :class="{ 'is-invalid': specError }">
                          <option v-for="speciality in specialities" :key="speciality.id" :value="speciality.Title">{{
                            speciality.Title }}
                          </option>
                        </select>
                        <div class="invalid-feedback" v-if="specError">{{ contactError }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card services-card">
                  <div class="card-body">
                    <h4 class="card-title">Education & Experience</h4>
                      <!-- clarance -->
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;"
                            class="mb-2">Qualifications
                            <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                          <VueMultiselect v-model="doctorDetails.qualifications" :options="qualificationsx" :max="4"
                            placeholder="Select qualification" label="label" track-by="value" multiple>
                            <template slot="tag" slot-scope="{ option }">
                              <span class="custom__tag">{{ option.label }}</span>
                            </template>
                          </VueMultiselect>
                          <div class="invalid-feedback" v-if="qualError">{{ qualError }}</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Experience
                            <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                          <input type="text" ref="doctorNameExp" class="form-control" v-model="doctorDetails.experience"
                            maxlength="2" @input="validateExperience" :class="{ 'is-invalid': experienceError }" />
                          <div class="invalid-feedback" v-if="experienceError">{{ experienceError }}</div>
                        </div>
                      </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">About Me</h4>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="mb-0">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Biography
                            <span
                              style="color: red; font-size: 10px; font-weight: bold; margin-left: 4px;">*</span></label>
                          <textarea ref="doctorNameDesp" class="form-control" v-model="doctorDetails.description"
                            rows="10" maxlength="1000" :class="{ 'is-invalid': desError }"></textarea>
                          <div class="invalid-feedback" v-if="desError">{{ desError }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Referee Details</h4>
                    <div class="registrations-info">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">
                            Referee Info
                          </label>
                          <input type="text" class="form-control" v-model="doctorDetails.refereecode" maxlength="12" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="submit-section submit-btn-bottom">
                  <b-button type="submit" class="btn btn-secondary">Save Changes</b-button>
                </div> -->
                <div class="center-container-btn" style="margin-bottom:30px">
                  <div class="change-avatar">
                    <div class="profile-img">
                      <img :src="profileImageUrl || defaultImageUrl" alt="User Image" />
                    </div>
                    <div class="upload-img">
                      <div class="change-photo-btn">
                        <span>
                          <i class="fa fa-upload"></i> Upload photo
                        </span>
                        <input type="file" class="upload" @change="uploadImage" />
                      </div>
                      <div>
                        <small class="form-text text-muted">Allowed JPG, JPEG or PNG. Max size of 2MB</small>
                      </div>
                      <div v-if="uploadedImageFile">
                        <small style="color: green; font-weight: bold;">
                          Image uploaded successfully</small>
                      </div>
                      <div v-if="!uploadedImageFile">
                        <small style="color: grey; font-weight: bold;">
                          Upload a profile image for doctor to make presence more identifiable</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="center-container-btn" style="margin-bottom:30px">
                  <div id="recaptcha-container" style="margin-bottom: 20px"></div>
                  <button type="submit" class="btn btn-primary submit-btn">Register</button>
                </div>
              </div>
              <div v-if="activeTab === 'social'">
                <div class="card-body">
                  <p v-if="errorvalidation">
                    <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
                      {{ errorvalidation
                      }}
                    </b-alert>
                  </p>
                  <div>
                    <b-alert v-model="showError" dismissible variant="danger">{{ error }}</b-alert>
                  </div>
                  <div>
                    <b-alert v-model="showSuccessAlert" variant="success" dismissible>{{ successMessage }}</b-alert>
                  </div>
                  <div class="card">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">
                            Facebook URL
                          </label>
                          <div class="input-group">
                            <input type="text" class="form-control" v-model="doctorDetails.facebookurl" maxlength="100">
                          </div>
                          </input>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">
                            Twitter URL
                          </label>
                          <div class="input-group">
                            <input type="text" class="form-control" v-model="doctorDetails.twitterurl" maxlength="100">
                          </div>
                          </input>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">
                            Instagram URL
                          </label>
                          <div class="input-group">
                            <input type="text" class="form-control" v-model="doctorDetails.instagramurl"
                              maxlength="100">
                          </div>
                          </input>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Pinterest
                            URL</label>
                          <div class="input-group">
                            <input type="text" class="form-control" v-model="doctorDetails.pintresturl" maxlength="100">
                          </div>
                          </input>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Linkedin
                            URL</label>
                          <div class="input-group">
                            <input type="text" class="form-control" v-model="doctorDetails.linkedinurl" maxlength="100">
                          </div>
                          </input>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label style="font-size: 12px; font-weight: bold; margin-left: 4px;" class="mb-2">Youtube
                            URL</label>
                          <div class="input-group">
                            <input type="text" class="form-control" v-model="doctorDetails.youtubeurl" maxlength="100">
                          </div>
                          </input>
                        </div>
                      </div>
                      <!-- <div class="center-container-btn" style="margin-top: 10px; margin-bottom:20px">
                      <button @click="setActiveTab('personal')" class="btn btn-primary submit-btn">Add doctor</button>
                    </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div </div>
    </div>
    <!-- <doctorfooter></doctorfooter> -->
  </div>
</template>
<script>
import axios from "axios";
import IndexBanner from "@/assets/json/specialization_settings_doctor.json";
import VueMultiselect from "vue-multiselect";
import defaultImageUrl from "@/assets/img/doctors/doctor-thumb-01.jpg";
import {
  CITY_NAME_MAX_LENGTH,
  OTHER_CITY_LABEL,
  OTHER_CITY_VALUE,
  cleanCityName,
  findCityByName,
  validateManualCityName
} from "@/services/cities";
import { signUp } from 'aws-amplify/auth';
import { signIn, resendSignUpCode } from 'aws-amplify/auth';
import { DOCTOR_POOL } from '@/AWSResources';
import { Amplify } from 'aws-amplify';
import medicalQualifications from '@/assets/json/doctor/MedicalQualifications.json';

export default {
  props: ['refereeid'],
  components: { VueMultiselect },
  data() {
    return {
      title: "Add new doctor",
      text: "Home",
      text1: "Add new doctor",
      sorting: ["Select", "Male", "Female"],
      file: null,
      filePreview: null,
      isFileOver: false,
      qualificationsx: medicalQualifications.qualifications,
      doctorDetails: {
        doctorname: "",
        gender: "",
        idp_id: "",
        age: "",
        languagesspoken: [],
        specialization: "",
        qualifications: "",
        experience: "",
        contactnumbers: "",
        email: "",
        area: null,
        city_id: null,
        areacode: "",
        address: "",
        registration_info: "",
        clincorhospname: "",
        description: "",
        weburl: "empty",
        appointment_duration: 0,
        refereecode: '',
      },
      onlyCountries: [
        'IN', 'US', 'GB', 'CA', 'AU',
        'AE', 'BH', 'KW', 'OM', 'QA', 'SA',
        'SG', 'MY', 'NZ'
      ],
      selectedCityOption: null,
      manualCityName: "",
      otherCityValue: OTHER_CITY_VALUE,
      otherCityLabel: OTHER_CITY_LABEL,
      cityNameMaxLength: CITY_NAME_MAX_LENGTH,
      languageOptions: [
        { label: "English", value: "English" },
        { label: "Hindi", value: "Hindi" },
        { label: "Kannada", value: "Kannada" },
        { label: "Tulu", value: "Tulu" },
        { label: "Malayalam", value: "Malayalam" },
        { label: "Konkani", value: "Konkani" },
        { label: "Urdu", value: "Urdu" },
        { label: "Tamil", value: "Tamil" },
        { label: "Telugu", value: "Telugu" },
      ],
      genders: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
        { label: 'Other', value: 'O' }
      ],
      autoFormat: false,
      defaultCountry: 'IN',
      showDismissibleAlert: false,
      errorvalidation: "",
      specialities: IndexBanner,
      nameError: "",
      emailError: "",
      email: '',
      phone_number: null,
      given_name: '',
      family_name: '',
      password: null,
      ageError: "",
      areacodeError: "",
      areaError: "",
      contactError: "",
      genderError: "",
      experienceError: "",
      regError: "",
      specError: "",
      qualError: "",
      conError: "",
      desError: "",
      imageFile: null,
      error: null,
      showError: false,
      showSuccessAlert: false,
      successMessage: "",
      profileImageUrl: "",
      defaultImageUrl: defaultImageUrl,
      showShareIcons: false,
      selectedQualification: null,
      activeTab: 'personal',
      recaptchaSiteKey: '6LebK30qAAAAAC_R7S23jQE4zG4YQ_NqPJbDNGIK',
      recaptchaWidgetId: null,
      newdoctorid: 0,
      uploadedImageFile: null,
      profileImageUrl: "",
    };
  },
  mounted() {
    this.$store.dispatch("loadCities");
    this.$nextTick(() => {
      if (typeof grecaptcha !== 'undefined') {
        this.renderRecaptcha();
      } else {
        console.error('reCAPTCHA not loaded. Retrying...');
        setTimeout(this.renderRecaptcha, 500);
      }
    });
  },
  computed: {
    cities() {
      return this.$store.getters.getCities;
    },
    citiesLoading() {
      return this.$store.getters.isCitiesLoading;
    },
    citiesError() {
      return this.$store.getters.getCitiesError;
    },
    isManualCity() {
      return this.selectedCityOption === OTHER_CITY_VALUE;
    }
  },
  methods: {
    onCityOptionChange() {
      this.areaError = "";
      if (!this.isManualCity) this.manualCityName = "";
    },
    // Turns the area dropdown (or the manually typed name) into a city_id and
    // the matching `area` name. Sets areaError and returns false on failure.
    async applySelectedCity() {
      if (!this.selectedCityOption) {
        this.areaError = "Please select the area.";
        return false;
      }

      if (!this.isManualCity) {
        const city = this.cities.find(c => c.city_id === this.selectedCityOption);
        if (!city) {
          this.areaError = "Please select the area.";
          return false;
        }
        this.doctorDetails.city_id = city.city_id;
        this.doctorDetails.area = city.name;
        this.areaError = "";
        return true;
      }

      const name = cleanCityName(this.manualCityName);
      const validationError = validateManualCityName(name);
      if (validationError) {
        this.areaError = validationError;
        return false;
      }

      // Reuse a city that is already in the list before asking the backend.
      const known = findCityByName(this.cities, name);
      if (known) {
        this.doctorDetails.city_id = known.city_id;
        this.doctorDetails.area = known.name;
        this.selectedCityOption = known.city_id;
        this.manualCityName = "";
        this.areaError = "";
        return true;
      }

      try {
        // The backend returns the existing city when one matches, so a typed
        // "mangalore" reuses "Mangalore" instead of creating a duplicate.
        const city = await this.$store.dispatch("resolveCityByName", { name });
        this.doctorDetails.city_id = city.city_id;
        this.doctorDetails.area = city.name;
        this.selectedCityOption = city.city_id;
        this.manualCityName = "";
        this.areaError = "";
        return true;
      } catch (error) {
        console.error("Error saving city:", error);
        this.areaError = error.response?.data?.detail || "Unable to save the city. Please try again.";
        return false;
      }
    },
    updateQualificationString() {
      this.doctorDetails.qualifications = this.selectedQualification ? this.selectedQualification.value : '';
      console.log("updateQualificationString", this.doctorDetails.qualifications);
    },
    validateNumber(event) {
      // Allow only numbers (0-9)
      if (!/^\d+$/.test(event.key)) {
        event.preventDefault(); // Prevent non-numeric input
      }
    },
    updateInput(phone, phoneObject) {
      this.doctorDetails.contactnumbers = phoneObject?.number || phone || "";
      this.isValidPhone = !!phoneObject?.valid;
      if (!this.isValidPhone) {
        this.contactError = "Please enter a valid contact number.";
      }
      else {
        this.contactError = "";
      }
    },
    renderRecaptcha() {
      if (typeof grecaptcha !== 'undefined') {
        this.recaptchaWidgetId = grecaptcha.render('recaptcha-container', {
          sitekey: this.recaptchaSiteKey,
        });
      } else {
        console.error('reCAPTCHA not loaded. Check the script.');
      }
    },
    async uploadImage(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!allowedTypes.includes(file.type)) {
        this.errorvalidation = "Only JPG, JPEG, or PNG images are allowed.";
        this.showDismissibleAlert = true;
        this.setAlertTimeout();
        return;
      }
      this.uploadedImageFile = file;
      this.profileImageUrl = await this.convertToBase64(file);
    },
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    },
    onSubmit() {
    //   this.doctorDetails.refereecode = sessionStorage.getItem('userdbid');
    //   if (!this.doctorDetails.refereecode) {
    //    this.errorvalidation =
    //      "Unexpected error ocurred";
    //  }
      if (typeof grecaptcha === 'undefined') {
        alert('reCAPTCHA is not loaded yet. Please try again.');
        return;
      }
      const recaptchaResponse = grecaptcha.getResponse(this.recaptchaWidgetId);
      if (recaptchaResponse === '') {
        this.showDismissibleAlert = true;
        this.errorvalidation =
          "Please complete the reCAPTCHA verification";
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      this.showDismissibleAlert = false;
      this.updateDoctorDetails();
    },
    setUserpool() {
      const poolConfig = DOCTOR_POOL;
      Amplify.configure(poolConfig);
    },
    setAlertTimeout() {
      setTimeout(() => {
        this.showDismissibleAlert = false;
        this.showSuccessAlert = false;
      }, 5000);
    },
    setActiveTab(tab) {
      if (tab==='personal')
        setTimeout(this.renderRecaptcha, 100);
      this.activeTab = tab;
    },
    validateName() {
      const regex = /^[a-zA-Z\s]*$/;
      if (!regex.test(this.doctorDetails.doctorname)) {
        this.nameError = "Name should only contain alphabetical characters.";
        return false;
      } else {
        this.nameError = "";
        return true;
      }
    },
    validateEmail() {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!regex.test(this.doctorDetails.email)) {
        this.emailError = "Please enter a valid email address.";
        return false;
      } else {
        this.emailError = "";
        return true;
      }
    },
    validateAge() {
      const regex = /^\d*$/;
      if (!regex.test(this.doctorDetails.age)) {
        this.ageError = "Age should contain only numbers.";
        return false;
      } else {
        this.ageError = "";
        return true;
      }
    },
    validateAreacode() {
      const regex = /^\d*$/;
      if (!regex.test(this.doctorDetails.areacode)) {
        this.areacodeError = "Areacode should contain only numbers.";
        return false;
      } else {
        this.areacodeError = "";
        return true;
      }
    },
    validateContactNumber() {
      const regex = /^\+\d{10,15}$/;
      if (!this.isValidPhone || !regex.test(this.doctorDetails.contactnumbers)) {
        this.contactError = "Please enter a valid contact number with country code.";
        return false;
      } else {
        this.contactError = "";
        return true;
      }
    },
    focusPhoneInput() {
      const phoneRef = this.$refs.phonenumber;
      const input = phoneRef?.$el?.querySelector("input");
      if (input) {
        input.focus();
        input.setSelectionRange(0, 0);
      }
    },
    focusRef(refName) {
      const ref = this.$refs[refName];
      const input = ref?.$el?.querySelector?.("input, textarea, select") || ref;
      if (input?.focus) {
        input.focus();
      }
      if (input?.setSelectionRange) {
        input.setSelectionRange(0, 0);
      }
    },
    getRegistrationErrorMessage(error) {
      console.error("Doctor registration failed:", error);

      const name = error?.name || error?.code;
      const serverMessage = error?.response?.data?.detail || error?.response?.data?.msg;

      if (name === "UsernameExistsException") {
        return "A doctor account already exists for this email. Please use another email or sign in.";
      }
      if (name === "InvalidParameterException" || name === "InvalidPasswordException") {
        return error.message || "Cognito rejected the account details. Please check email and phone format.";
      }
      if (serverMessage) {
        return serverMessage;
      }
      return error?.message || "Registration failed. Please check the details and try again.";
    },
    validateExperience() {
      const regex = /^\d*$/;
      if (!regex.test(this.doctorDetails.experience)) {
        this.experienceError = "Experience should contain only numbers.";
        return false;
      } else {
        this.experienceError = "";
        return true;
      }
    },

    async updateDoctorDetails() {
      try {
        if (!this.doctorDetails.doctorname) {
          // this.errorvalidation = "The doctor’s name cannot be empty";
          this.showDismissibleAlert = true;
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.focusRef("doctorNameInput");
          this.nameError = "The doctor’s name cannot be empty";
          this.setAlertTimeout();
          return;
        }
        if (!this.validateName()) {
          // this.errorvalidation = "Please enter a valid name";
          this.showDismissibleAlert = true;
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.focusRef("doctorNameInput");
          this.nameError = "The doctor’s name cannot be empty";
          this.setAlertTimeout();
          return;
        }
        if (!this.doctorDetails.email || !this.validateEmail()) {
          // this.errorvalidation = "Please enter a valid email";
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.showDismissibleAlert = true;
          this.activeTab = 'personal';
          this.focusRef("doctorNameEmail");
          this.emailError = "Please enter a valid email";
          this.setAlertTimeout();
          return;
        }
        if (!this.doctorDetails.age || !this.validateAge()) {
          // this.errorvalidation = "Please enter a valid age";
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.showDismissibleAlert = true;
          this.activeTab = 'personal';
          this.focusRef("doctorNameAge");
          this.ageError = "Please enter a valid age";
          this.setAlertTimeout();
          return;
        }

        if (!this.doctorDetails.gender) {
          this.errorvalidation = "Please enter gender";
          window.scrollTo({ top: 0, behavior: "smooth" });
          this.showDismissibleAlert = true;
          this.activeTab = 'personal';
          this.genderError = "Please enter gender";
          this.setAlertTimeout();
          return;
        }

        if (
          !this.doctorDetails.languagesspoken ||
          this.doctorDetails.languagesspoken.length > 50
        ) {
          this.errorvalidation =
            "Please enter the languages spoken; the entry must not exceed 50 characters";
          this.showDismissibleAlert = true;
          window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.setAlertTimeout();
          return;
        }

        if (!this.doctorDetails.email) {
          // this.errorvalidation = "Please enter the email";
          this.showDismissibleAlert = true;
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.focusRef("doctorNameEmail");
          this.emailError = true;
          this.setAlertTimeout();
          return;
        }

        if (
          !this.doctorDetails.registration_info ||
          this.doctorDetails.registration_info.length > 50
        ) {
          // this.errorvalidation =
          //   "Please enter the registration info; the entry must not exceed 50 characters";
          this.showDismissibleAlert = true;
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.focusRef("doctorNameReg");
          this.regError = "Please enter the registration info; the entry must not exceed 50 characters";
          this.setAlertTimeout();
          return;
        } else { this.regError = ""; }

        if (
          !this.doctorDetails.clincorhospname ||
          this.doctorDetails.clincorhospname.length > 100
        ) {
          // this.errorvalidation =
          //   "Please enter the clinic name; the entry must not exceed 100 characters";
          this.showDismissibleAlert = true;
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.focusRef("doctorNameClinic");
          this.clinicError = "Please enter the clinic name; the entry must not exceed 100 characters";
          this.setAlertTimeout();
          return;
        } else { this.clinicError = ""; }

        if (!(await this.applySelectedCity())) {
          this.errorvalidation = this.areaError;
          this.showDismissibleAlert = true;
          window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.setAlertTimeout();
          return;
        }

        if (!this.doctorDetails.areacode || !this.validateAreacode()) {
          // this.errorvalidation = "Please enter valid area code";
          this.showDismissibleAlert = true;
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.focusRef("doctorNameAreaCode");
          this.areacodeError = "Please enter valid area code";
          this.setAlertTimeout();
          return;
        } else { this.areacodeError = ""; }

        if (
          !this.doctorDetails.address ||
          this.doctorDetails.address.length > 500
        ) {
          // this.errorvalidation =
          //   "Please enter the address; the entry must not exceed 500 characters";
          this.showDismissibleAlert = true;
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.focusRef("doctorNameAddress");
          this.addressError = "Please enter the address; the entry must not exceed 500 characters";
          this.setAlertTimeout();
          return;
        } else { this.addressError = ""; }

        if (
          !this.doctorDetails.specialization ||
          this.doctorDetails.specialization.length > 50
        ) {
          this.errorvalidation =
            "Please select the specialization.";
          this.showDismissibleAlert = true;
          window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          // this.$refs.doctorNameSpec.focus();
          // this.$refs.doctorNameSpec.setSelectionRange(0, 0);
          this.specError = "Please select the specialization.";
          this.setAlertTimeout();
          return;
        } else { this.specError = ""; }

        if (
          !this.doctorDetails.qualifications ||
          this.doctorDetails.qualifications.length > 1000
        ) {
          // this.errorvalidation =
          //   "Please enter the qualifications; the entry must not exceed 1000 characters";
          this.showDismissibleAlert = true;
          this.activeTab = 'personal';
          this.qualError = "Please enter the qualifications; the entry must not exceed 1000 characters";
          this.setAlertTimeout();
          return;
        } else { this.qualError = ""; }

        if (!this.doctorDetails.experience || !this.validateExperience()) {
          // this.errorvalidation = "Please enter the valid experience";
          this.showDismissibleAlert = true;
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.focusRef("doctorNameExp");
          this.experienceError = "Please enter the valid experience";
          this.setAlertTimeout();
          return;
        } else { this.experienceError = ""; }

        if (
          !this.doctorDetails.contactnumbers ||
          !this.validateContactNumber()
        ) {
          // this.errorvalidation = "Please enter the valid contact numbers";
          this.showDismissibleAlert = true;
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.focusPhoneInput();
          this.conError = "Please enter the valid contact numbers";
          this.setAlertTimeout();
          return;
        } else { this.conError = ""; }

        if (!this.doctorDetails.description) {
          // this.errorvalidation = "Please enter the description";
          this.showDismissibleAlert = true;
          // window.scrollTo({ top: 0, behavior: "smooth" });
          this.activeTab = 'personal';
          this.focusRef("doctorNameDesp");
          this.desError = "Please enter the description";
          this.setAlertTimeout();
          return;
        } else { this.desError = ""; }

        const doctorPayload = {
          ...this.doctorDetails,
          languagesspoken: this.doctorDetails.languagesspoken
          .map(lang => lang.value)
            .join(", "),
          qualifications: Array.isArray(this.doctorDetails.qualifications)
            ? this.doctorDetails.qualifications.map(q => q.value).join(", ")
            : this.doctorDetails.qualifications,
        };
        const { isSignUpComplete, userId, nextStep } = await signUp({
          username: doctorPayload.email,
          password: "Changemenow@12345",
          options: {
            userAttributes: {
              email: doctorPayload.email,
              phone_number: doctorPayload.contactnumbers,
              given_name: doctorPayload.doctorname,
              family_name: doctorPayload.doctorname,
              gender: doctorPayload.gender,
            },
            autoSignIn: false
          }
        });
        doctorPayload.idp_id = userId;
        const response = await axios.post(
          `doctors/`,
          doctorPayload
        );
        this.newdoctorid = response.data.doctorid;
        if (this.uploadedImageFile) {
          const formData = new FormData();
          formData.append("image_file", this.uploadedImageFile);
          await axios.post(
            `doctors/doc-upload-image?doctorid=${this.newdoctorid}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          );
        }
        this.errorvalidation = "";
        this.showSuccessAlert = true;
        this.successMessage = "Doctor created successfully!";
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.activeTab = 'personal';
        Object.keys(this.doctorDetails).forEach(key => {
          this.doctorDetails[key] = "";
        });
        this.setAlertTimeout();
        this.doctorDetails = {
          doctorname: "",
          gender: "",
          idp_id: "",
          age: "",
          languagesspoken: [],
          specialization: "",
          qualifications: "",
          experience: "",
          contactnumbers: "",
          email: "",
          area: null,
          city_id: null,
          areacode: "",
          address: "",
          registration_info: "",
          clincorhospname: "",
          description: "",
          weburl: "empty",
          appointment_duration: 0,
          refereecode: '',
        };
        this.selectedCityOption = null;
        this.manualCityName = "";
        this.areaError = "";
      this.doctorDetails.refereecode = sessionStorage.getItem('userdbid');
      if (!this.doctorDetails.refereecode) 
        this.$router.push("/referee-dashboard");
      this.$router.push("/doctor-login");
      } catch (error) {
        this.showDismissibleAlert = true;
        this.errorvalidation = this.getRegistrationErrorMessage(error);
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.activeTab = 'personal';
        this.setAlertTimeout();
      }
    },
    onDragOver(event) {
      event.preventDefault();
      this.isFileOver = true;
    },
    onDragLeave(event) {
      event.preventDefault();
      this.isFileOver = false;
    },
    onFileChange(event) {
      const file = event.target.files[0];
      this.file = file;
      this.filePreview = URL.createObjectURL(file);
    },
    onFileDrop(event) {
      event.preventDefault();
      this.isFileOver = false;
      const file = event.dataTransfer.files[0];
      this.file = file;
      this.filePreview = URL.createObjectURL(file);
    },
    removeImage() {
      this.file = null;
      this.filePreview = null;
      this.$refs.fileInput.value = "";
    }
  },
  created() {
    this.setUserpool();
  },

};
</script>
<style scoped>
.card {
  margin-bottom: 40px;
  /* background-color: #f0f0f0f8; */
  padding: 16px;
  border-radius: 8px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
  border: 1px solid #cccccce3;
}

.d-flex {
  display: flex;
}

.form-control:disabled {
  background-color: hsla(0, 0%, 94%, 0.149);
  color: black;
}

.align-items-center {
  align-items: center;
}

.ml-auto {
  margin-left: auto;
}

.grey-icon {
  color: grey;
  transition: color 0.3s ease;
}

.grey-icon:hover {
  color: black;
}

.share-icons {
  display: flex;
  align-items: center;
  position: absolute;
  right: 50px;
}

.file-over {
  border: 2px dashed #ccc;
}

.file-option img {
  width: 120px;
  height: 120px;
}

.call-lable {
  position: relative;
}

.remove-btn {
  position: absolute;
  top: 23px;
  right: 45%;
}

.remove-btn i {
  color: #e63333;
}

.center-container-btn {
  display: grid;
  place-items: center;
}

.card-title-main {
  text-align: center;
  margin-bottom: 40px;
}
</style>
